<template>
    <div>
        <div v-if="checkout">
            <div class="bg-green text-white p-4 rounded-md font-text text-xl mb-4 mt-4">
                Hang tight, we're getting your invoice ready and will send you there shortly!
            </div>
        </div>
        <Robot
            :customer-api-token="this.customerApiToken"
            :customer-data-link="(this.customerDataLink && this.customerDataLink.first_name) ? customerDataLink : null"
            mode="external"/>
        </div>
</template>

<script>
import Vue from 'vue'
import Vuex from 'vuex'
import RobotLib from 'robot-lib'
Vue.use(RobotLib)
Vue.use(Vuex)
import store from './state/store'
import VueSession from 'vue-session'
Vue.use(VueSession)

export default {
    name: "Robot2",
    store:store,
    data() {
        return {
            custId: null,
            show: 'hidden ',
            checkout: false
        };
    },
    props: {
        customerDataLink: {
            default: null
        },
        customerApiToken : {
            default: null
        },
        customerCacheExpires : {
            default: null
        },
        cart: {
            default: null
        }
    },
    mounted() {
        let urlParams = new URLSearchParams(window.location.search);
        if(urlParams.get('checkout')) {
            this.checkout = true
        }
        // console.log('store state', this.$store.state)
        // console.log('mount')
        // console.log('cart', this.cart)
        // console.log('customer data link', this.customerDataLink)
        // console.log('customerApiToken', localStorage.getItem('customerApiToken'))
        // console.log('customerData', this.customerDataLink)
        // console.log('cacheExpires', this.customerCacheExpires)

        this.$store.state.cart = this.cart;

        // console.log('store state', this.$store.state)

        if(this.customerDataLink && this.customerDataLink.first_name) {
            // console.log('customerdataLink true')
            localStorage.setItem('customerApiToken', this.customerApiToken)
            localStorage.setItem('customerApiInitialized', true)
            localStorage.setItem('customerCacheExpires', this.customerCacheExpires)
        } else {
            localStorage.removeItem('customerApiToken')
            localStorage.removeItem('customerCacheExpires')
        }
        this.$root.$on('redirectRoute', (path) => {
            // console.log(path)
            let queryString = path.path.split('?')
            let cartId = queryString[1].split('=')
            // console.log('cartId', cartId[1])
            document.location.href = '/shop/cart/' + cartId[1]
        })
        this.$root.$on('robotLogin', (e) => {
            document.location.href = '/shop/my-account/auth/login/true'
        })
    },
    methods: {
        closeLogin: function () {
            this.show = 'hidden '
        }
    }
}
</script>
<style>
@import '~robot-lib/dist/robot-lib.esm.css';
</style>
